import { ListEventTypesPayload, ListEventTypesQueryPayload } from '@src/entities/Event/includes/types';

export const DefaultListEventTypesPayload: ListEventTypesPayload = {};

export const DefaultListEventTypesQueryPayload: ListEventTypesQueryPayload = [
  'Event',
  'ListEventTypes',
  DefaultListEventTypesPayload,
];
